// The two app services currently share data. DEV only permits read-only API calls.
export const DEV_BACKEND_ORIGIN = 'https://dev-backend-cortechap.azurewebsites.net';

export function isDevReadOnly() {
  const configured = process.env.REACT_APP_DEV_READ_ONLY === 'true';
  const onDevPortal =
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname === 'dev-portal.cortechap.com.ar';

  return configured || Boolean(onDevPortal);
}

export function getDevRequestBlockReason(config, readOnly = isDevReadOnly()) {
  if (!readOnly) return null;

  if (!config || typeof config.url !== 'string' || !config.url.trim()) {
    return 'DEV_API_URL_INVALID';
  }

  let target;
  try {
    target = new URL(config.url, config.baseURL || DEV_BACKEND_ORIGIN);
  } catch (_) {
    return 'DEV_API_URL_INVALID';
  }

  // Even an accidentally hard-coded production URL must not be called from DEV.
  if (target.origin !== DEV_BACKEND_ORIGIN) {
    return 'DEV_API_TARGET_BLOCKED';
  }

  const method = String(config.method || 'get').toLowerCase();
  if (!['get', 'head', 'options'].includes(method)) {
    return 'DEV_READ_ONLY';
  }

  // These GET routes trigger POST calls to external workflows in the backend.
  if (/^\/v1\/customers\/[^/]+\/reports\/(?:balance|historicalBalance)\/?$/i.test(target.pathname)) {
    return 'DEV_FLOW_DISABLED';
  }

  return null;
}
